import { Attr } from '../Data/Attr';
export var Field;
(function (Field) {
    function categorical(formula, name, alias, frame) {
        const source = "FIELD";
        return { ...Attr.categorical(formula, name), source, alias, frame };
    }
    Field.categorical = categorical;
    function ordinal(formula, name, alias, type, role, frame, opts = {}) {
        const source = "FIELD";
        return {
            ...Attr.ordinal(formula, name, type, role, opts),
            source,
            alias,
            frame,
        };
    }
    Field.ordinal = ordinal;
    function quantitative(formula, name, alias, frame, opts = {}) {
        const source = "FIELD";
        return { ...Attr.quantitative(formula, name, opts), source, alias, frame };
    }
    Field.quantitative = quantitative;
})(Field || (Field = {}));
